<div class="partner-details-drawer">
  <div class="drawer-header">
    <div class="title-container">
      <h2>Detalles del maestro</h2>
    </div>
    <button (click)="close()" nz-button nzType="text" nzShape="circle" class="close-button">
      <span nz-icon nzType="close" nzTheme="outline"></span>
    </button>
  </div>

  <div class="drawer-content"></div>

</div>
